import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CKEditorService } from '../../note-editor/ckeditor.service';
import * as global from '../../../../app/includes/global'
import { AuthService } from 'src/app/services/auth.service';
import { TicketService } from '../ticket.service';
import { FacilityService } from 'src/app/services/facility.service';
import { ToastrService } from 'ngx-toastr';
import { PatientListService } from '../../patient-list/patient-list-service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { SnfWcNurseAssociationService } from '../../snf_wc_nurse-snf_wc_nurse-association/snf_wc_nurse_association.service';
import { TranscriptionCreateService } from '../../transcription-create/transcription-create.service';
import { DashboardService } from '../../dashboard/dashboard.service';
import { NoteEditorService } from "../../note-editor/note-editor.service";
import { CompanyService } from 'src/app/services/Modules/company.service';
import { ZDTicket, TicketObj } from './ticket.model';
import { StatsigService } from 'src/app/services/statsig.service';

import * as moment from 'moment';

@Component({
  selector: 'app-add-tickets',
  templateUrl: './add-tickets.component.html',
  styleUrls: ['./add-tickets.component.css']
})

export class AddTicketsComponent implements OnInit {

  selected = 'none';
  patientSelected = 'none'
  cke4Config;
  currentUser: any;
  globals = global;
  ticketIdForEdit: any;
  patientName: any = '';
  ticketModel = {
    first_name: '',
    last_name: '',
    middle_name: '',
    title: '',
    facility_id: '',
    patient_name: '',
    priority: '',
    description: '',
    company_id: '',
    file: '',
    patient_id: '',
    service_date:moment().format('YYYY-MM-DD'),
    facilityTitle: '',
    companyName: ''
  };
  facilities: any;
  showIcon: boolean = false;
  searchText: any;
  patientSearch: any;
  filePath: any;
  patients = [];
  disableSubmitButton: boolean = false;
  isSelectPatient:boolean = false;
  providers: any;
  provider_id:any;
  facilityTitle: string;
  companyName: string;

  constructor(
    private ckeditorService: CKEditorService,
    private dialogRef: MatDialogRef<AddTicketsComponent>,
    private authService: AuthService,
    private ticketService: TicketService,
    private facilityService: FacilityService,
    private toastr: ToastrService,
    private _patientListService: PatientListService,
    private _snfWcNurseAssociationService: SnfWcNurseAssociationService,
    private _transcriptionCreateService: TranscriptionCreateService,
    private noteEditorService: NoteEditorService,
    @Inject(MAT_DIALOG_DATA) public data: any = AddTicketsComponent,
    private dashboardService: DashboardService,
    private companyService: CompanyService,
    // @Inject(MAT_DIALOG_DATA) public data: any,
    private loader: NgxUiLoaderService,
    private statsigService: StatsigService,
  ) {

    this.cke4Config = {
      ...this.ckeditorService.getDefaultConfig(),
      editable: true
    };
    this.currentUser = this.authService.currentUser;

    console.log('DATA recevied to edit', data);
    if (data) {
      this.ticketModel.title = data['title'];
      setTimeout(() => {
        if(data.facilityId !== undefined) {
          this.ticketModel.facility_id = data.facilityId;
        } 
        else if(typeof(data['facility_id_ref']) == 'string') {
          this.ticketModel.facility_id = data['facility_id_ref'];
        }
        
      }, 0)
      this.ticketModel.service_date = data['date_of_service']? data['date_of_service']:moment(data["census_date"]).format('YYYY-MM-DD')
      this.ticketModel.patient_name = data["patient_name"];
      this.ticketModel.patient_id = data['patient_id'] ? data['patient_id'] : data['_id'];
      this.ticketModel.priority = data['priority'];
      this.ticketModel.description = data['description'];
      this.ticketIdForEdit = data['_id'];
      this.ticketModel.first_name = data['first_name'];
      this.ticketModel.last_name = data['last_name'];
      this.ticketModel.middle_name = data['middle_name'];

      if (!this.ticketModel.middle_name) { this.ticketModel.middle_name = '' }
      if (this.currentUser.user_type == global.USER_TYPE.DOCTOR || this.currentUser.user_type == global.USER_TYPE.SNF_WC_NURSE && this.ticketModel.facility_id['_id']) {
        this.ticketModel.facility_id = this.ticketModel.facility_id['_id'];
      }
      if (this.ticketModel.first_name || this.ticketModel.middle_name || this.ticketModel.last_name) {
        this.patientName = this.ticketModel.first_name + ' ' + this.ticketModel.middle_name + ' ' + this.ticketModel.last_name;
        this.ticketModel.patient_name = this.ticketModel.first_name + ' ' + this.ticketModel.middle_name + ' ' + this.ticketModel.last_name;
      }
    }
  }

  ngOnInit(): void {
    this.initAssociatedProvidersListForAll();
    this.getFacilities();
    this.setTicketModelCompanyName(this.currentUser.company_id);

    // if (this.patientName != "") {
    //   this.ticketModel.description = "Patient Name: " + this.patientName;
    // }
    if (this.currentUser.user_type === global.USER_TYPE.DOCTOR || this.currentUser.user_type === global.USER_TYPE.SNF_WC_NURSE || this.currentUser.user_type === global.USER_TYPE.MEDICAL_ASSISTANT || this.currentUser.user_type === global.USER_TYPE.TRANSCRIBER) {
      this.isSelectPatient = true
    }
  }
  initAssociatedProvidersListForAll() {
    if (this.currentUser.user_type === global.USER_TYPE.MEDICAL_ASSISTANT) {
      const providerId = this.data?.providerId;
      this._transcriptionCreateService.getAssociatedDoctorsListForMA().subscribe(async (response: any) => {
        if (response.status === 200) {
          this.providers = response.data;
          if (this.providers.length) {
            if (providerId) {
              this.provider_id = providerId;
            }
            else {
              this.provider_id = this.providers[0]._id;
            }
            this.getAssociatedProviderFacility();
          }
        }
      });
    }
    else if (this.currentUser.user_type === global.USER_TYPE.BUSINESS_OFFICER) {
      this._transcriptionCreateService.getAssociatedDoctorsListForBO(this.currentUser._id, this.currentUser.company_id, this.currentUser.user_type)
        .subscribe(async (response: any) => {
          if (response.status === 200) {
            this.providers = response.data;
            if (this.providers.length) {
              this.provider_id = this.providers[0]._id;
              this.getAssociatedProviderFacility();
            }
          }
        });
    }
    else if (this.currentUser.user_type == global.USER_TYPE.TRANSCRIBER) {
        this.noteEditorService.getAssociatedDoctorsList(this.currentUser.company_id).subscribe(async (response: any) => {
          if (response.status === 200) {
            this.providers = response.data;
            if(this.providers.length){
              this.provider_id = this.providers[0]._id;
              this.getAssociatedProviderFacility();
            }
          }
        });
  }
  }
  getAssociatedProviderFacility(){
    this.facilityService.getMyFacilities(this.provider_id).subscribe(data => {
    this.facilities = data.data.array;
      if(!this.ticketModel.facility_id) {
        this.ticketModel.facility_id = this.facilities[0]._id;
                this.getFacilityPatients(this.ticketModel.facility_id)
      }
        this.showIcon = true;
    });
}
  closeDialog() {
    this.dialogRef.close();
  }

  getFacilities() {
    return new Promise<void>((resolve, reject) => {
      const filter = {
        associated_snf_wc_nurse_ids: this.authService.currentUser._id,
      };
      const nurseProjection = {
        first_name: 1,
        last_name: 1,
        title: 1,
      };
      const facilityProjection = {
        title: 1,
        pcc_facId: 1,
        pcc_2_legged_authentication: 1,
        source: 1
      };
      if (this.currentUser.user_type === global.USER_TYPE.SNF_WC_NURSE) {
        this._snfWcNurseAssociationService.getFacilityAssociatedSnfWcNurses(filter, nurseProjection, facilityProjection).subscribe((response: any) => {
          if (response.status === 200 && response.data.length > 0) {
            this.facilities = response.data;
            if(!this.ticketModel.facility_id ) {
              this.ticketModel.facility_id = this.facilities[0]._id;
            }
                    this.getFacilityPatients(this.ticketModel.facility_id)
            this.showIcon = true;
          }
        });
      }
      else {
        this.facilityService.getMyFacilities().subscribe(data => {

          this.facilities = data.data.array;
          // console.log('facilities', this.facilities);
          if(!this.ticketModel.facility_id) {
            this.ticketModel.facility_id = this.facilities[0]._id;
          }
                  this.getFacilityPatients(this.ticketModel.facility_id)
          this.showIcon = true;
          resolve();
        }, error => {
          reject('error => ' + error.toString());
        });
      }
    });
  }

  onReadyCkeditor(e) {
    const { editor } = e;
    this.ckeditorService.ckeditorRemoveTitle(editor);

    editor.on('paste', (e) => {
      const { data, editor } = e;
      if (data.type === 'text') {
        const modifiedhtml = e.data.dataValue
          .split('<br />')
          .join('<p><br /></p>');
        //@ts-ignoreticketModel
        var filter = new CKEDITOR.filter('p b br'),
          // Parse the HTML string to a pseudo-DOM structure.
          // @ts-ignore
          fragment = CKEDITOR.htmlParser.fragment.fromHtml(modifiedhtml),
          // @ts-ignore
          writer = new CKEDITOR.htmlParser.basicWriter();

        filter.applyTo(fragment);
        fragment.writeHtml(writer);
        const html = writer.getHtml();
        e.data.dataValue = html;
      }
    });
  }

  isPCCFacility(facility_id) {
    for (const facility of this.facilities) {
      if (facility_id === facility._id) {
        if (facility.pcc_facId) {
          return true;
        }
      }
    }
  }

  async getFacilityPatients(id, facility_changed?) {
    // console.log(id)
    var details = {
      id: <string>null,
      auth_key: <string>null,
      usertype: <any>null,
      primary_doctor_id: <string>null,
      index: <string>null,
      all: <Boolean>true
    };
    details.id = this.currentUser._id;
    details.auth_key = this.currentUser.auth_key;
    details.usertype = this.currentUser.user_type;
    details.index = null;
    details.all = true;
    if (facility_changed) this.ticketModel.patient_id = "";

    // this.loader.startLoader('loader-033');
    // const company_id = this.params.id;

    const response: any = await this._patientListService.getPatientsByFacilityId_v2(details, null, { facility: id }, null).toPromise();
    if (response.status === 200) {

      this.facilityName(id);
      this.patients = response.data.array;
      // this.loader.stopLoader('loader-033');
      // this.toastr.success('Patients Fetched from DB Successfully.', 'Success');

      // console.log('all patients', this.pccPatients, this.patients);

    }

  }

  selectPatient(patient) {
    this.ticketModel.first_name = patient.first_name;
    this.ticketModel.patient_id = patient._id;
    this.ticketModel.last_name = patient.last_name;
    this.ticketModel.patient_name = patient.last_name + " " + patient.first_name;
    // console.log("select patient", this.ticketModel)
  }

  facilityName(f_id: string) {
    this.facilityService.getMyFacilities().subscribe({
      next: (data) => {
        this.facilities = data.data.array;
        const facility = this.facilities.find(facility => facility._id === f_id);
        if (facility) {
          this.ticketModel.facilityTitle = facility.title;
        } else {
          this.ticketModel.facilityTitle = 'Unknown Facility';
          this.toastr.warning(`Facility with id ${f_id} not found`, 'Warning');
        }
      },
      error: () => {
        this.toastr.error('Failed to fetch facility information. Please try again later.', 'Error');
        this.ticketModel.facilityTitle = 'Unknown Facility';
      }
    });
  }

  async setTicketModelCompanyName(company_id: string) {
    try {
      const response = await this.companyService.getCompanyName(company_id).toPromise();
      if (response.status === 200 && response.data) {
        this.ticketModel.companyName = response.data.name;
      } else {
        this.ticketModel.companyName = 'Unknown Company';
        this.toastr.warning('Company information not found', 'Warning');
      }
    } catch (error) {
      this.ticketModel.companyName = 'Unknown Company';
      this.toastr.error('Failed to fetch company information. Please try again later.', 'Error');
    }
  }

  cleanDescription (input: string) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(input, 'text/html');
    const text = doc.body.innerText|| "";
    const result = text.split('\n').join('')
    return result;
  }

  formatTicketObject(ticketObj: TicketObj): string {
    return `Name: ${ticketObj.Name}
    Patient: ${ticketObj.Patient}
    Facility: ${ticketObj.Facility}
    Company: ${ticketObj.Company}
    Description: ${ticketObj.Description}`;
  }

  submitTicketForm(formObj = null) {
    const infoToast = this.toastr.info('Submitting Ticket', 'Please wait...', { disableTimeOut: true });
    this.disableSubmitButton = true;
    this.loader.startLoader('loader-033');
    if (this.data?.title) {
      this.ticketService.editTicket(this.ticketIdForEdit, this.ticketModel).subscribe((response: any) => {
        if (response.status == 200) {
          this.loader.stopLoader('loader-033');
          // console.log("Respons data", response);
          this.toastr.success(`Ticket submitted Successfully!`, 'Success');
          this.dialogRef.close(response.data);
          this.disableSubmitButton = false;
          this.toastr.clear(infoToast.toastId);

        }
      });
    } else {
      if (this.statsigService.checkGate('zendesk_api_post_email')) {
        this.ticketModel.company_id = this.currentUser.company_id;
        const currentUser = JSON.parse(localStorage.getItem('currentUser'))
        let userEmail = currentUser.email
        let userName = `${currentUser.first_name} ${currentUser.last_name}`
        let cleanDes = this.cleanDescription(this.ticketModel.description)
        const ticketObj = {
          Name: userName,
          Patient: this.ticketModel.patient_name,
          Facility: this.ticketModel.facilityTitle,
          Company:  this.ticketModel.companyName,
          Description: cleanDes,
        }
        let formattedTicket = this.formatTicketObject(ticketObj)
        const zdTicketModel = new ZDTicket(this.ticketModel.title, formattedTicket, userName, userEmail);
        const zendeskTicket = JSON.stringify(zdTicketModel);
        this.ticketService.addToZendesk(zendeskTicket).subscribe();
      }
    }
      this.ticketService.addTicket(this.ticketModel).subscribe((response: any) => {
        if (response.status == 200) {
          // console.log("Respons data", response);
          this.loader.stopLoader('loader-033');
          this.toastr.success(`Ticket submitted Successfully!`, 'Success');
          this.closeDialog();
          this.disableSubmitButton = false;
          this.toastr.clear(infoToast.toastId)
        }
      });
  }

  onImageSelect(event) {

    this.ticketModel.file = event.target.files[0];
    this.filePath = event.target.files[0].name;
    // console.log("file Path", this.ticketModel.file);
  }
  
  fileName() {
    return this.filePath;
  }

  deleteFile() {
    this.filePath = "";
    this.ticketModel.file = '';
  }
  handleDateChange(date){
    this.ticketModel.service_date = date
  }
}
